import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../endPoints/endPoints";
import { ITransport, TransportFull } from "../interfaces/ITransport";

export const transportApi = createApi({
  reducerPath: "transport",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.TRANSPORT,
  }),
  tagTypes: ["transport"],
  endpoints: (builder) => ({
    getAllTransport: builder.query<ITransport[], void>({
      query() {
        return {
          url: ``,
          method: "GET",
          credentials: "include",
        };
      },
      transformResponse: (resp: TransportFull[]) => {
        const transport = resp.map(unit => ({
            id: unit.id,
            number: unit.number,
            type: unit.model.id,
            type_name: unit.model.name
        }))
        return transport;
      },
      providesTags: ["transport"],
    }),
  }),
});

export const { useGetAllTransportQuery } = transportApi;
